import React from 'react'
import Map from '../../../../../../common/components/map'
import _ from 'lodash';
import { format } from '../../../../../../common/services/date.service';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function TripBasicInfoComponent({ transporters, agents, orderDetails, tripsDetails, getShippingType, ConvertMinutes }: any) {




    return (
        <>
            <AccordionContainer
                child={
                    <><div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="ServiceType"
                            name="LogisticsServiceType"
                            isDisabled
                            //   onValueChange={(event: any) => {
                            //     onInnerBasicFormChange(
                            //       event.target.value,
                            //       'ShipmentPId'

                            //     );
                            //   }}
                            type="text"
                            value={tripsDetails?.LogisticsServiceType} />

                        <InputContainer
                            label="schedule date"
                            name="LogisticsSeShippedDateUtcrviceType"
                            isDisabled
                            //   onValueChange={(event: any) => {
                            //     onInnerBasicFormChange(
                            //       event.target.value,
                            //       'LogisticsServiceType'

                            //     );
                            //   }}
                            type="date"
                            value={tripsDetails?.ShippedDateUtc} />
                        <InputContainer
                            label="Transporter"
                            labelField="Name"
                            isDisabled
                            list={transporters}
                            //   onValueChange={(event: any) => {
                            //     onInnerBasicFormChange(
                            //       event.target.value,
                            //       'TransportAgentId'
                            //     );
                            //   }}
                            optionName='Choose Transporter'
                            type="select"
                            value={tripsDetails?.TransporterId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Agent"
                            labelField="Name"
                            isDisabled
                            list={agents}
                            //   onValueChange={(event: any) => {
                            //     onInnerBasicFormChange(
                            //       event.target.value,
                            //       'TransportAgentId'
                            //     );
                            //   }}
                            optionName='Choose Agent'
                            type="select"
                            value={tripsDetails?.TransportAgentId}
                            valueField="Id"
                        />

                        <InputContainer
                            label="TotalDistance (Km)"
                            name="TotalDistance"
                            isDisabled
                            //   onValueChange={(event: any) => {
                            //     onInnerBasicFormChange(
                            //       event.target.value,
                            //       'ShipmentPId'

                            //     );
                            //   }}
                            type="number"
                            value={tripsDetails?.TotalDistance} />



                    </div>
                    </>
                }
                expandedPanel="basicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}